import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopConfirm from '@omilia/popconfirm';

import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';
import { entityType } from 'types';

import './style.scss';

class EntityInspectHeader extends Component {
  static propTypes = {
    currentEntity: entityType.isRequired,
    selectedTabIndex: PropTypes.number,
    onAddFeature: PropTypes.func,
    onConnectDictionary: PropTypes.func,
    onDelete: PropTypes.func,
  };

  handleDelete = () => {
    const {
      currentEntity: { id },
      onDelete,
    } = this.props;

    onDelete(id);
  };

  renderGeneralTabButtons = () => {
    const {
      onAddFeature,
      selectedTabIndex,
      currentEntity: { archived, xpack_resource: xpack },
    } = this.props;

    if (selectedTabIndex === 2 || archived || xpack) {
      return null;
    }

    return (
      <div styleName="entity-header">
        <InspectButton
          isHeader
          data-action="add-feature"
          data-test="add-feature"
          onClick={onAddFeature}
        >
          + Add a Feature
        </InspectButton>
        <PopConfirm
          confirmLabel="Yes"
          declineLabel="Cancel"
          placement="left"
          title="Are you sure you want to delete this entity?"
          onConfirm={this.handleDelete}
        >
          <InspectButton isHeader data-test="delete-entity-button">
            Delete Entity
          </InspectButton>
        </PopConfirm>
      </div>
    );
  };

  renderContentTabButtons = () => {
    const {
      selectedTabIndex,
      onConnectDictionary,
      currentEntity: { archived },
    } = this.props;

    if (selectedTabIndex === 1 || archived) {
      return null;
    }
    return (
      <InspectButton
        isHeader
        data-test="link-to-dictionary"
        onClick={onConnectDictionary}
      >
        + Link to Dictionary
      </InspectButton>
    );
  };

  render() {
    return (
      <InspectHeader>
        {this.renderGeneralTabButtons()}
        {this.renderContentTabButtons()}
      </InspectHeader>
    );
  }
}

export default EntityInspectHeader;
